import { OverlayProps } from './types';
import { StyledOverlay } from './style';

export const Overlay: React.FC<OverlayProps> = ({
  children,
  preview = false,
  showOverlay = true,
  visible = true,
  overlayPercentage = 50,
  zIndex = 10,
}) => (
  <StyledOverlay
    preview={preview}
    showOverlay={showOverlay}
    visible={visible}
    overlayPercentage={overlayPercentage}
    zIndex={zIndex}
  >
    {children}
  </StyledOverlay>
);
